export default "__VITE_ASSET__BLhbuEWm__"